var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'tw-flex tw-cursor-pointer tw-justify-between tw-items-center tw-rounded-lg tw-py-2 tw-px-4 tw-font-poppins tw-font-medium tw-text-sm',
    { 'tw-bg-white tw-text-[#1F2229]': _vm.checked }
  ],on:{"click":_vm.toggle}},[_c('div',{staticClass:"tw-flex tw-items-center tw-gap-2"},[_c('i',{class:{
        'fas fa-check-circle': _vm.checked,
        'far fa-circle tw-color-white tw-opacity-50': !_vm.checked,
      },style:({ color: _vm.checked ? _vm.color : '' })}),_vm._v("\n    "+_vm._s(_vm.portfolio.name)+"\n  ")]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fas fa-circle tw-hidden",style:({ color: _vm.color })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }